import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Sparkles } from "lucide-react";
import axios from "axios";
import { setToken } from "../lib/api";
import OAuthOnboarding from "./OAuthOnboarding";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function AuthCallback({ onSuccess }) {
  const navigate = useNavigate();
  const processed = useRef(false);
  const [onboardData, setOnboardData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
    const sessionId = params.get("session_id");

    // Clean fragment from URL
    try {
      const url = new URL(window.location.href);
      url.hash = "";
      window.history.replaceState({}, "", url.toString());
    } catch (err) { console.warn("URL hash cleanup failed", err); }

    if (!sessionId) {
      setError("Sessione Google mancante");
      return;
    }

    axios.post(`${API}/auth/google/callback`, { session_id: sessionId })
      .then((res) => {
        if (res.data.linked && res.data.token) {
          setToken(res.data.token);
          toast.success(`Benvenuto ${res.data.user?.name || ""}!`);
          onSuccess?.();
          navigate("/", { replace: true });
        } else if (res.data.needs_onboarding) {
          setOnboardData(res.data);
        } else {
          setError("Risposta inattesa dal server");
        }
      })
      .catch((err) => {
        setError(err.response?.data?.detail || "Errore login Google");
      });
  }, [navigate, onSuccess]);

  if (onboardData) {
    return (
      <OAuthOnboarding
        user={onboardData.user}
        onboardToken={onboardData.onboard_token}
        onComplete={() => {
          onSuccess?.();
          navigate("/", { replace: true });
        }}
      />
    );
  }

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#FBF9F6] p-6">
        <div className="max-w-md rounded-3xl border border-[#E8E1D9] bg-white p-8 text-center">
          <Sparkles className="mx-auto h-10 w-10 text-amber-500" />
          <h2 className="mt-4 font-display text-2xl font-bold text-[#2D2926]">
            Login non riuscito
          </h2>
          <p className="mt-2 text-[#5C5855]">{error}</p>
          <button
            onClick={() => navigate("/", { replace: true })}
            className="mt-6 rounded-full bg-[#FF7C43] px-6 py-3 font-semibold text-white hover:bg-[#E66A35]"
          >
            Torna al login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#FBF9F6]">
      <div className="flex flex-col items-center gap-3">
        <Loader2 className="h-10 w-10 animate-spin text-[#FF7C43]" />
        <p className="text-sm font-semibold uppercase tracking-[0.2em] text-[#C87941]">
          Accesso in corso…
        </p>
      </div>
    </div>
  );
}
